import { useCallback, useEffect, useState } from "react";

import { arraysAreEqual } from "@/utils/arrayUtils";

type SerialPortFilter = {
  vendorId?: number;
  productId?: number;
};

export const useSerialPorts = (filters?: SerialPortFilter[]) => {
  const [ports, setPorts] = useState<SerialPort[]>([]);

  const refreshPorts = useCallback(async () => {
    if (!navigator.serial) {
      return;
    }
    const newPorts = await navigator.serial.getPorts();
    setPorts(ports => {
      const filteredPorts = filters
        ? newPorts.filter(port => {
            const portInfo = port.getInfo();
            return filters.some(filter => {
              return (
                (!filter.vendorId || portInfo.usbVendorId === filter.vendorId) &&
                (!filter.productId || portInfo.usbProductId === filter.productId)
              );
            });
          })
        : newPorts;
      return arraysAreEqual(filteredPorts, ports) ? ports : filteredPorts;
    });
  }, [filters]);

  useEffect(() => {
    const interval = setInterval(refreshPorts, 1000);
    return () => clearInterval(interval);
  }, [refreshPorts]);

  return ports;
};
